import './spinner.scss';

const Spinner = () => {
  return <div class="loader"></div>;
};

export default Spinner;
